import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import GeneralChargeCriteriaContMain from "presentation/view/container/Criteria/GeneralChargeCriteriaContMain";

CommonEntrypoint(<GeneralChargeCriteriaContMain/>)